import { FiCheckCircle, FiCode, FiCpu, FiDatabase, FiLayers } from 'react-icons/fi';

const ICONS = [FiCode, FiLayers, FiDatabase, FiCpu];

export const AboutSection = ({ about = {}, skills = [] }) => (
    <section id="sobre-mi" className="PB__section PB__section--white PB__about_section">
        <div className="PB__about_aurora PB__about_aurora--warm" aria-hidden="true" />
        <div className="PB__about_aurora PB__about_aurora--cool" aria-hidden="true" />
        <div className="PB__about_horizon" aria-hidden="true" />
        <div className="PB__container PB__about_grid">
            <div>
                <div className="PB__section_kicker">Perfil</div>
                <h2 className="PB__section_title">sobre <em>mi</em></h2>
                <div className="PB__section_line" />
                {about.paragraph_1 && <p className="PB__lead">{about.paragraph_1}</p>}
                {about.paragraph_2 && <p className="PB__lead">{about.paragraph_2}</p>}
                {(about.badges || []).length > 0 && (
                    <div className="PB__badges">
                        {about.badges.map((badge) => <span key={badge}><FiCheckCircle /> {badge}</span>)}
                    </div>
                )}
            </div>
            <div className="PB__skill_grid">
                {skills.map((skill, index) => {
                    const Icon = ICONS[index % ICONS.length];
                    return (
                        <article className="PB__skill_card" key={skill.id || skill.title}>
                            <span className="PB__skill_icon"><Icon /></span>
                            <h3>{skill.title}</h3>
                            <p>{skill.items}</p>
                        </article>
                    );
                })}
            </div>
        </div>
    </section>
);
